import {Html5Qrcode} from "html5-qrcode";

class QrPageHandler
{
    constructor(ajax_qr_validate_qr_code_result_url) {
        this.qr_code_scanner = null;
        this.$qr_code_scanner_modal = $('#qr-scanner-modal');
        this.ajax_qr_validate_qr_code_result_url = ajax_qr_validate_qr_code_result_url;
        this.ajax_validate_qr_code_request = null;

        this.initListeners();
    }

    initQrCodeScanner() {
        this.qr_code_scanner = new Html5Qrcode('qr-reader-container');

        const config = {fps: 10, qrbox: {width: 250, height: 250}};
        this.qr_code_scanner.start({facingMode: "environment"}, config, (decodedText, decodedResult) => {
            this.onScanSuccess(decodedText, decodedResult);
        });
    }

    stopQrCodeScanner() {
        this.qr_code_scanner.stop();
    }

    onScanSuccess(decodedText, decodedResult) {
        // handle the scanned code as you like, for example:
        console.log(`Code matched = ${decodedText}`, decodedResult);

        if(this.ajax_validate_qr_code_request){
            this.ajax_validate_qr_code_request.abort();
        }

        this.ajax_validate_qr_code_request = $.ajax({
            url    : this.ajax_qr_validate_qr_code_result_url,
            method : 'POST',
            data   : {
                scanned_code: decodedText
            },
            dataType: 'json',
            success: function (response) {
                if(response.qr_detail_url){
                    window.location.href = response.qr_detail_url;
                }
            },
            error: function (jq_xhr, text_status, error_thrown){
                if('abort' !== text_status){
                    $('#qr-reader-error-message').removeClass('d-none');
                }
            }
        });
    }

    initListeners() {
        const self = this;

        $('#qr-scanner-modal-button').on('click', function (evt) {
            evt.preventDefault();

            self.$qr_code_scanner_modal.modal('show');

            self.initQrCodeScanner();
        });

        self.$qr_code_scanner_modal.on('hidden.bs.modal', function (evt) {
            self.stopQrCodeScanner();
        });
    }
}

new QrPageHandler(ajax_qr_validate_qr_code_result_url);
